import script from "./VideoTranslationTask.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoTranslationTask.vue?vue&type=script&setup=true&lang=js"

import "./VideoTranslationTask.vue?vue&type=style&index=0&id=ed91a3e4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed91a3e4"]])

export default __exports__